/* eslint-disable */
export default function() {
  window.__insp = window.__insp || [];
  __insp.push(["wid", window.gon.inspectlet_token]);
  (function() {
      function __ldinsp(){var insp = document.createElement("script"); insp.type = "text/javascript"; insp.async = true; insp.id = "inspsync"; insp.src = ("https:" == document.location.protocol ? "https" : "http") + "://cdn.inspectlet.com/inspectlet.js"; var x = document.getElementsByTagName("script")[0]; x.parentNode.insertBefore(insp, x); }
      __ldinsp();
  })();
};
